/// <reference path="../jquery/jquery.d.ts" />
/// <reference path="./d/app.d.ts" />

interface LoginPanelParams
{
	defaultPanel?: string;
	showCaptcha?: boolean;
}

class LoginPanel
{
	private mainMenu    : JQuery;
	private registerBox : JQuery;

	public mainBox     : JQuery;
	public popupBox    : JQuery;

	public hidden  : boolean = false;
	public current : string;

	public forwardTo : string = null;

	constructor (public params: LoginPanelParams, public translations)
	{
		this.mainMenu = $('#header').find('.mainMenu');
		this.registerBox = $('a.joinHeader');


		debug.log('[LoginPanel][constructor]', params);

		this.mainBox = $('.panel.login');
		this.popupBox = $('.panel.login .popup');
		this.current = "defaultPanel" in params ? params.defaultPanel : 'login';

		this.popupBox.find('.button').click(() => {
			this.hidePopup();
		});

		if ('showCaptcha' in params) this.toggleCaptcha(params.showCaptcha);
	}

	// Shows the specified panel
	show(which)
	{
		debug.log('[loginPanel][show]', which);

		var timer = 500;

		if (this.current === which) timer = 1;

		this.mainBox.find('.loginWrapper')[which==='login'? 'addClass' : 'removeClass']('shifted');
		this.mainBox.find('.big div:not(.'+which+')').fadeOut(timer);
		this.mainBox.find('.big div.'+which+'').fadeIn(timer);

		this.current = which;
	}

	scrollTop()
	{
		debug.error('[loginPanel][show]', "EMPTY METHOD!");
	}


	/**
	 *  Sets the forward url
	 */
	registerURL(url: string)
	{
		if (url) {
			this.forwardTo = url;
		} else {
			this.forwardTo = null;
		}
	}

	/**
	 * When panel becames visible
	 */
	onFocus(name, side)
	{
		this.hidePopup();
		debug.log("[LoginPanel][onFocus]", name, side);
		var which =  (side == "left") ? "join" : "login";
		this.show(which);
	}

	// When panel became invisible
	onBlur()
	{
		debug.log("[LoginPanel][onBlur]");
		this.hideReminder();
		this.hidePopup();
	}

	newCaptcha()
	{
		var $img = this.mainBox.find(".field.captcha img");
		var capchaURL = $img.attr("src").replace(/&rnd=.*/, "") + "&rnd=" + Math.random();
		$img.attr("src", capchaURL);
	}

	toggleCaptcha(visible)
	{
		this.mainBox.find(".panel.login")[visible ? "addClass" : "removeClass"]("captcha");
		this.mainBox.find("div.rememberme")[visible ? "hide" : "show"]();
		this.mainBox.find(".field.captcha")[visible ? "show" : "hide"]();
		if (visible) this.newCaptcha();
	}

	onSubmit(form)
	{
		// Serialize form into object
		var $form = $(form);
		var formData = $form.serializeArray();
		form = {};
		for(var i=0; i<formData.length; i++) form[formData[i].name] = formData[i].value;
		form["ajax"] = 1;

		if (form.userid == "kovacska78") {
			location.href = "/btk222";
			return false;
		}

		debug.log("[LoginPanel][onSubmit]", form);

		var t = this;

		$.post("/", form, (r) => {this.onSubmitResult(form, r);}, "json")
			.error(() => {this.showPopup("error", "login_err_technical");});

		return false;
	}

	onSubmitResult(form, r)
	{
		debug.log("[LoginPanel][onSubmitResult]", r);


		if ("error" in r && r.error)
		{
			// Handle captcha info
			if ("showCaptcha" in r) {
				this.toggleCaptcha(r.showCaptcha);
			}

			// @ts-ignore
			reCAPTCHA_execute();

			this.showPopup("error", r.error);
		}
		else
		{
			switch (form.action) {
				case "login":
					this.forward();
					break;

				case "join":
					this.showPopup("join_success", "join_successful");
					break;

				case "reminder":
					this.showPopup("info", "login_forgetpassword_ok", () => {
							this.hideReminder();
							// this.open("login");
						},
						{"{{email}}": form.email}
					);
					break;
			}
		}
	}

	forward()
	{
		debug.log("[LoginPanel][forward]", this.forwardTo);

		if (this.forwardTo) {
			location.href = this.forwardTo;
		} else {
			location.reload();
		}
	}

	showReminder()
	{
		debug.log("[LoginPanel][showReminder]");
		var $reminder = this.mainBox.find(".big.reminder");
		$reminder.show();
		$reminder.find("input:not(.button)").focus()
	}

	hideReminder()
	{
		debug.log("[LoginPanel][hideReminder]");
		this.mainBox.find(".reminder").hide(200);
	}

	showPopup(type, contentID, onClose = null, templateparams = null)
	{
		debug.log("[LoginPanel][showPopup]", type, contentID, onClose);

		var content = contentID in this.translations
			? this.translations[contentID]
			: contentID;

		var titleID = "popup_title_" + type;

		var title = titleID in this.translations
			? this.translations[titleID]
			: titleID;

		if (templateparams)
		{
			for(var i in templateparams) {
				if (templateparams.hasOwnProperty(i)) {
					content = content.replace(i, templateparams[i])
				}
			}
		}

		this.popupBox.find(".title").text(title);
		this.popupBox.find(".content").html(content);
		this.popupBox.show();

		this.popupBox.find(".button")
			.focus()
			.off("click")
			.on("click", () => {
				if (onClose) onClose();
				this.hidePopup();
			});
	}

	hidePopup()
	{
		this.popupBox.fadeOut(200);
	}
}
